import React, { useState, useEffect } from 'react';

const CHANNEL_URL = 'https://www.youtube.com/@CoracaoCristao-go7ms';

function formatDate(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
}

const PlayIcon = ({ size = 16, color = '#365E4B' }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
    <path d="M5.5 3.5v9L13 8 5.5 3.5z" fill={color} />
  </svg>
);

function YouTubeSection() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch('https://feescrita-138417386089.us-central1.run.app/api/videos')
      .then((response) => (response.ok ? response.json() : []))
      .then((data) => setVideos(Array.isArray(data) ? data.slice(0, 3) : []))
      .catch(() => setVideos([]));
  }, []);

  // Sem vídeos (feed indisponível), a seção não aparece
  if (!videos.length) return null;

  return (
    <section className="fe-videos">
      <div className="fe-videos-head">
        <div>
          <h2>Assista no Coração Cristão</h2>
          <p>Os vídeos mais recentes do nosso canal no YouTube</p>
        </div>
        <a
          className="fe-videos-cta"
          href={`${CHANNEL_URL}?sub_confirmation=1`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <PlayIcon size={14} color="#FFFFFF" />
          Inscrever-se no canal
        </a>
      </div>
      <div className="fe-videos-grid">
        {videos.map((video) => (
          <a
            key={video.id}
            className="fe-video-card"
            href={video.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="fe-video-thumb">
              <img src={video.thumbnail} alt={video.title} loading="lazy" />
              <span className="fe-video-play"><PlayIcon /></span>
            </div>
            <div className="fe-video-body">
              <h3>{video.title}</h3>
              <span className="fe-video-date">{formatDate(video.published)}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default YouTubeSection;
